import { UPDATE_USER, UPDATE_USER_SUCCESSFUL, UPDATE_USER_FAILED } from './actionTypes';

const initialState = {
    updateUserError: null, updateUsermessage: null, loadingUpdateUser: false
}

const updateAccount = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_USER:
            state = {
                ...state,
                user: null,
                loadingUpdateUser: true,
                updateUserError: null
            }
            break;
        case UPDATE_USER_SUCCESSFUL:
            state = {
                ...state,
                loadingUpdateUser: false,
                updateUsermessage: action.payload,
                updateUserError: null
            }
            break;
        case UPDATE_USER_FAILED:
            state = {
                ...state,
                updateUsermessage: null,
                loadingUpdateUser: false,
                updateUserError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default updateAccount;